export default __webpack_public_path__ + "static/media/Bracers of Lunacy.6a5000ea.jpg";